import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '~/constants/react-query'
import { useActiveOrgId } from '~/hooks/org/useActiveOrgId'
import { useServerRequests } from '~/hooks/useRequests'
import { CardBalancesResponse } from '~/types/cards'
import { EvmAddress } from '~/utils/address'

type Response = CardBalancesResponse

export const useCardBalances = (
  address?: EvmAddress.Type,
  { showSpamTokens = false }: { showSpamTokens?: boolean } = {},
) => {
  const activeOrgId = useActiveOrgId()
  const { serverGetRequest } = useServerRequests()

  const query = useQuery({
    queryKey: [QUERY_KEYS.CARD_BALANCES, activeOrgId, address, showSpamTokens],
    enabled: !!activeOrgId && !!address,
    queryFn: async () => {
      const params: Record<string, string> = { orgId: activeOrgId ?? '' }
      if (showSpamTokens) params.showSpamTokens = 'true'
      const response = await serverGetRequest<Response>({
        path: `/api/org/cards/${address}/balances`,
        params,
      })
      return response ? response.data : { balances: [], totalValue: 0 }
    },
  })

  return {
    balances: query.data?.balances ?? [],
    totalValue: query.data?.totalValue ?? 0,
    isLoading: query.isLoading,
    isError: query.isError,
  }
}
